import 'intersection-observer';

if (!('timeout' in AbortSignal)) {
  // @ts-ignore
  AbortSignal.timeout = function (ms: number): AbortSignal {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), ms);
    return controller.signal;
  };
}

const supportsProperEventTarget = (() => {
  try {
    new EventTarget();
    return true;
    // eslint-disable-next-line unused-imports/no-unused-vars
  } catch (e) {
    return false;
  }
})();

if (!supportsProperEventTarget) {
  class EventTargetPolyfill {
    private listeners: Record<string, EventListener[]> = {};

    addEventListener(type: string, listener: EventListener): void {
      if (!this.listeners[type]) {
        this.listeners[type] = [];
      }
      this.listeners[type].push(listener);
    }

    removeEventListener(type: string, listener: EventListener): void {
      if (this.listeners[type]) {
        this.listeners[type] = this.listeners[type].filter(
          (l) => l !== listener,
        );
      }
    }

    dispatchEvent(event: Event): boolean {
      if (this.listeners[event.type]) {
        this.listeners[event.type].forEach((listener) => {
          try {
            listener(event);
          } catch (error) {
            console.error('Error in event listener:', error);
          }
        });
      }
      return true;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).EventTarget = EventTargetPolyfill;
  window.EventTarget = EventTargetPolyfill;
}
